import { routingEnabled } from 'utils/ui/app';
import MultiVoipWithRouting from './MultiVoipWithRouting';
import MultiVoipInternal from './MultiVoipInternal';

export type MultiVoipProps = {
  controls?: boolean;
  className?: string;
};

const MultiVoip: React.FC<MultiVoipProps> = ({ controls, className }) => {
  return routingEnabled() ? (
    <MultiVoipWithRouting controls={controls} className={className} />
  ) : (
    <MultiVoipInternal controls={controls} className={className} />
  );
};

export default MultiVoip;
